module.exports = __webpack_public_path__ + "static/img/avatar-bar.834d9363.png";